import { useCurrentUser } from './user'

export const Switches: Record<string, boolean> =
  typeof window !== 'undefined' ? ((window as any).WAFFLE_SWITCHES ?? {}) : {}

console.info('Global Switches', Switches)

// Off: no new Nirvana business, and its Resubmit and Create options are hidden from staff.
export const CARRIER_NIRVANA_ENABLED = 'CARRIER_NIRVANA_ENABLED'

export function useFeatureFlag(flag: string): boolean {
  const { user } = useCurrentUser({ enabled: false })
  return user?.flags[flag] ?? false
}
